import RequestPageMUI from "./RequestPageMUI";

const DanaBreakfastRequests = () => {
    return (
        <RequestPageMUI 
            title="Breakfast - Dana Requests"
            fetchUrl="/get-breakfast-dana-requests"
            editEndpoint="edit-dana-request"
            deleteEndpoint="delete-dana-request"
            statusEndpoint="dana-request"
            dateFields={['dana_event_date', 'created_at', 'updated_at', 'approved_at', 'rejected_at', 'deleted_at']}
            hiddenFields={['ip_address', 'source_id', 'yearly_reference_no']}
            filterField="meal_type"
            filterValue="breakfast"
            showFilter={false}
            serverSideSorting={true}
            enableColumnReorder={true}
            persistToDatabase={true}
            tableId="breakfast_dana_requests"
        />
    );
};

export default DanaBreakfastRequests;